export default __webpack_public_path__ + "static/media/ArchiveSuccessIcon.7d2dd9ed.svg";